import React, { useEffect, useState, useCallback } from 'react'
import { Input, Select } from '../../../components/ModalInputs'
import Modal from 'react-responsive-modal'
import { useFormik } from 'formik'
import Button from '../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { getOrganizations, getSpeciality, createEntity, updateEntity } from '../../../actions/profotbor'
import { MILITARY_RANKS, STUDY_FORMS } from '../../../assets/const'
import { useNavigate } from 'react-router-dom'
import styles from '../styles.module.scss'
import Confirmation from '../../../components/Confirmation/Confirmation'


export default function ModalComponent ({open, data, closeModal, addMode}) {
  
  const modalTitle = addMode ? 'Добавление профотбора' : 'Редактирование профотбора'

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { organizations, speciality } = useSelector(state => state.profotbor)

  useEffect(() => {
    !organizations.length && dispatch(getOrganizations())
  }, [])
  
  const createEntityHandler = async (values) => {
    const id = await dispatch(createEntity(values))
    if (!id) return;
    navigate(`/profotbor/${id}`)
  }
  
  const updateEntityHandler = async ({id, ...values}) => {
    const success = await dispatch(updateEntity(id, values))
    success && closeModal()
  }

  const {
    values,
    errors,
    touched,
    dirty,
    submitCount,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: data || {},
    enableReinitialize: true,
    onSubmit: addMode ? createEntityHandler : updateEntityHandler
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => { if (dirty) setConfirmClose(true); else closeModal() }, [dirty, closeModal])
  const acceptConfirmClose = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmClose = useCallback(() => setConfirmClose(false), [])

  return (
      <Modal
        open={open}
        onClose={handleClose}
        closeOnEsc={true}
        closeOnOverlayClick={true}
        showCloseIcon={false}
        animationDuration={1}
        classNames={{modal: styles.addEditModal}}
      >
        <h1>{modalTitle}</h1>

        <Input
          label='Дата проведения'
          name='dt'
          value={values.dt}
          onChange={handleChange}
          type='date'
          error={error('dt')}
          />

        <Input
          label='Название мероприятия'
          name='name'
          value={values.name}
          onChange={handleChange}
          error={error('name')}
          />

        <Select
          label='ВУЗ'
          name='vuz'
          value={values.vuz}
          onChange={handleChange}
          error={error('vuz')}
        >
          <option value=''>Не выбрано</option>
          {organizations.map((item) => <option value={item.id}>{item.correct_name}</option>)}
        </Select>

        <Select
          label='Звание'
          name='zvanie'
          value={values.zvanie}
          onChange={handleChange}
          error={error('zvanie')}
        >
          <option value=''>Не выбрано</option>
          {MILITARY_RANKS.map((item) => <option value={item}>{item}</option>)}
        </Select>

        <Input
          label='Должность'
          name='doljnost'
          value={values.doljnost}
          onChange={handleChange}
          error={error('doljnost')}
        />

        <Input
          label='ФИО'
          name='fio'
          value={values.fio}
          onChange={handleChange}
          error={error('fio')}
          />

        <Select
          label='Форма проведения'
          name='forma_provedeniya'
          value={values.forma_provedeniya}
          onChange={handleChange}
          error={error('forma_provedeniya')}
        >
          <option value=''>Не выбрано</option>
          {STUDY_FORMS.map((item) => <option value={item}>{item}</option>)}
        </Select>

        <div>
          <Button onClick={handleSubmit}>Сохранить</Button>
          <Button onClick={closeModal}>Отмена</Button>
        </div>

        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmClose}
            rejectConfirmation={rejectConfirmClose}
          />
        )}
      </Modal>
  )
}
